// extracted by mini-css-extract-plugin
export default {"contenido":"Tarjeta_contenido__Pbxod","portada":"Tarjeta_portada__PCabC","numero":"Tarjeta_numero__rMJ1m"};